<div fxLayout="column" fxLayoutAlign="start center">
  <div class="content-block dx-card responsive-paddings ocl-top-container" style="width: 95vw">
    <h3 class="content-block">Users</h3>
  </div>
  <div class="content-block dx-card responsive-paddings ocl-bottom-container" style="width: 95vw">
    <dx-data-grid
      (onToolbarPreparing)="onToolbarPreparing($event)"
      [dataSource]="store.value"
      [allowColumnReordering]="true"
      [showRowLines]="true"
      [showBorders]="true"
      [hoverStateEnabled]="true"
      [highlightChanges]="true"
      height="60vh"
      [allowColumnResizing]="true"
      [wordWrapEnabled]="true"
      [columnHidingEnabled]="isPhoneOrTablet"
      (onSelectionChanged)="itemsSelected($event)">
      <dxo-scrolling mode="multiple"></dxo-scrolling>
      <dxo-pager
        [visible]="true"
        [allowedPageSizes]="[10, 20, 50, 100]"
        [showInfo]="true"
        [showNavigationButtons]="true"
        [showPageSizeSelector]="true"
      ></dxo-pager>
      <dxo-remote-operations [filtering]="true" [sorting]="true" [paging]="true"></dxo-remote-operations>
      <dxo-filter-row [showOperationChooser]="true" [visible]="true"></dxo-filter-row>
      <dxo-selection mode="single"></dxo-selection>
      <dxo-sorting mode="multiple"></dxo-sorting>
      <dxo-filter-panel [visible]="true"></dxo-filter-panel>
      <dxi-column caption="Email" dataField="email" [hidingPriority]="isPhoneOrTablet ? 4 : null"
                  minWidth="160"></dxi-column>
      <dxi-column caption="Last Name" dataField="lastName" [hidingPriority]="isPhoneOrTablet ? 3 : null"
                  [allowSorting]="false" [allowFiltering]="true"></dxi-column>
      <dxi-column caption="First Name" dataField="firstName" [hidingPriority]="isPhoneOrTablet ? 2 : null"
                  [allowSorting]="false" [allowFiltering]="true"></dxi-column>
      <dxi-column caption="Last Activity" cellTemplate="lastLoginCellTemplate"
                  [hidingPriority]="isPhoneOrTablet ? 0 : null"></dxi-column>

      <div *dxTemplate="let cellInfo of 'lastLoginCellTemplate'">
        {{ parseDate(cellInfo.data.lastLoginInstant) }}
      </div>

      <dxi-column caption="Role" dataField="role" [headerFilter]="true" [hidingPriority]="isPhoneOrTablet ? 1 : null"
                  [allowSorting]="false"></dxi-column>

      <dxi-column
        caption=""
        [width]="240"
        [allowFiltering]="false"
        [allowSorting]="false"
        cellTemplate="editingTemplate"
        [visible]="!isPhoneOrTablet"
      ></dxi-column>

      <div *dxTemplate="let cellInfo of 'editingTemplate'">
        <div fxLayout="row" style="width: 150px">
          <dx-button
            icon="edit"
            text="Edit"
            style="margin-right: 4px"
            (onClick)="sendToEdit(cellInfo.data)"
          ></dx-button>
          <dx-button icon="trash" text="Delete" style="margin-right: 4px"
                     (click)="remove(cellInfo.data.id)"></dx-button>
          <dx-button icon="fa fa-repeat" text="Resend" (click)="resendEmail(cellInfo.data.email)"></dx-button>
        </div>
      </div>
    </dx-data-grid>
  </div>
</div>

<dx-speed-dial-action
  *ngIf="isPhoneOrTablet && selectedRowData.length > 0"
  icon="edit"
  label="Edit"
  [index]="1"
  (onClick)="sendToEdit(selectedRowData[0])">
</dx-speed-dial-action>
<dx-speed-dial-action
  *ngIf="isPhoneOrTablet && selectedRowData.length > 0"
  icon="trash"
  label="Delete"
  [index]="2"
  (onClick)="remove(selectedRowData[0].id)">
</dx-speed-dial-action>
<dx-speed-dial-action
  *ngIf="isPhoneOrTablet && selectedRowData.length > 0"
  icon="fa fa-repeat"
  label="Resend"
  [index]="3"
  (onClick)="resendEmail(selectedRowData[0].email)">
</dx-speed-dial-action>

<div [style.display]="formVisible ? 'inline' : 'none'">
  <app-user-form
    [formVisible]="formVisible"
    (formSubmitted)="submitted()"
    [user]="selectedUser"
    [roles]="roles"
    [existentUsers]="users"
  ></app-user-form>
</div>
